export default __webpack_public_path__ + "static/media/theme_junglen.8f9468fd.jpg";